// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.delete.RentalManagerUserPropertyDeleteWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias } from '../..';

interface DeleteParams {
  listingAlias: ListingAlias;
  reason?: string;
}

export const RentalManagerUserPropertyDeleteWebApiHandler_delete_Path = '/api/web/v1/users/properties/delete';

/**
 * Delete a property
 * @deprecated
 */
export const RentalManagerUserPropertyDeleteWebApiHandler_delete = (getParams: DeleteParams, client = getClient()) => {
  return httpFrontEndRequest<DeleteParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyDeleteWebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
